module.exports = __webpack_public_path__ + "static/media/back-seguro-celular.40c6a3c2.jpg";